// src/components/AllSessionsModal.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './AllSessionsModal.css';

const skillNameMap = {
  "Words in Context": "words_in_context",
  "Text Structure and Purpose": "text_structure_and_purpose",
  "Cross-Text Connections": "cross_text_connections",
  "Central Ideas and Details": "central_ideas_and_details",
  "Command of Evidence": "command_of_evidence",
  "Inferences": "inferences",
  "Boundaries": "boundaries",
  "Form, Structure, and Sense": "form_structure_and_sense",
  "Rhetorical Synthesis": "rhetorical_synthesis",
  "Transitions": "transitions",
  "Algebra": "algebra",
  "Geometry": "geometry",
  "Data Analysis": "data_analysis"
};

// Create a reverse map for displaying skill names
const skillDisplayNameMap = Object.fromEntries(
  Object.entries(skillNameMap).map(([key, value]) => [value, key])
);

const SESSIONS_PER_PAGE = 20;

const AllSessionsModal = ({ sessions, onClose }) => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);

  const displayedSessions = sessions.slice(0, currentPage * SESSIONS_PER_PAGE);
  const hasMoreSessions = displayedSessions.length < sessions.length;

  const handleReviewSession = (sessionId) => {
    onClose();
    navigate(`/review-session/${sessionId}`);
  };

  const loadMore = () => {
    setCurrentPage(prevPage => prevPage + 1);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-btn" onClick={onClose}>&times;</button>
        <h2>All Past Study Sessions</h2>

        {sessions.length === 0 ? (
          <p>No past sessions found.</p>
        ) : (
          <>
            <ul className="past-sessions-list modal-list">
              {displayedSessions.map((session) => (
                <li key={session.session_id} className="session-item">
                  <div className="session-info">
                    <strong>Date:</strong> {session.timestamp ? new Date(session.timestamp).toLocaleString() : 'N/A'}<br/>
                    {/* FIXED: Use skillDisplayNameMap for correct display */}
                    <strong>Skills:</strong> {session.skills.map(s => skillDisplayNameMap[s] || s).join(', ')}<br/>
                    <strong>Difficulty:</strong> {session.difficulty}
                  </div>
                  <button
                    className="review-session-btn"
                    onClick={() => handleReviewSession(session.session_id)}
                  >
                    Review Session
                  </button>
                </li>
              ))}
            </ul>
            {hasMoreSessions && (
              <button onClick={loadMore} className="load-more-btn">
                Load More Sessions ({displayedSessions.length} / {sessions.length})
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default AllSessionsModal;